/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import './portfolio.css';
import Menu from './Menu';

const Portfolio = () => {
	const [items, setItems] = useState(Menu);
	const [activeFilter, setActiveFilter] = useState('Everything');
	const filterItem = (categoryItem) => {
		const updatedItems = Menu.filter((curElem) => {
			return curElem.category === categoryItem;
		});

		setItems(updatedItems);
		setActiveFilter(categoryItem);
	};

	return (
		<section
			className='work container section'
			id='work'
		>
			<h2 className='section__title'>Recent Works</h2>

			<div className='work__filters'>
				<span
					className={`work__item ${
						activeFilter === 'Everything' ? 'active' : ''
					}`}
					onClick={() => {
						setItems(Menu);
						setActiveFilter('Everything');
					}}
				>
					Everything
				</span>
				<span
					className={`work__item ${
						activeFilter === 'Logo Design' ? 'active' : ''
					}`}
					onClick={() => filterItem('Logo Design')}
				>
					Logo Design
				</span>
				<span
					className={`work__item ${
						activeFilter === 'Development' ? 'active' : ''
					}`}
					onClick={() => filterItem('Development')}
				>
					Development
				</span>
				<span
					className={`work__item ${
						activeFilter === 'UI/UX Design' ? 'active' : ''
					}`}
					onClick={() => filterItem('UI/UX Design')}
				>
					UI/UX Design
				</span>
			</div>

			<div className='work__container grid'>
				{items.map((elem) => {
					const { id, image, title, category, link } = elem;
					return (
						<div
							className='work__card'
							key={id}
						>
							<div className='work__thumbnail'>
								<img
									src={image}
									alt=''
									className='work__img'
								/>
								<div className='work__mask'></div>
							</div>

							<span className='work__category'>{category}</span>
							<h3 className='work__title'>{title}</h3>
							<a
								href={link}
								className='work__button'
								target='_blank'
								rel='noreferrer'
							>
								<i className='icon-link work__button-icon'></i>
							</a>
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default Portfolio;
